module.exports = __webpack_public_path__ + "img/10 11 12 13 FRAME_Portrait.ee7af404.png";